export default "__VITE_ASSET__ac559874__"